import React from 'react'
import { Card } from 'antd'

import './index.css'

export default function CardContainer({
  currentTheme = 'light',
  children,
  title = '',
  loading = false,
  ...cardProps
}) {
  return (
    <Card
      className='crd'
      title={title}
      loading={loading}
      bordered
      hoverable
      {...cardProps}
    >
      {children}
    </Card>
  )
}
